module.exports = __webpack_public_path__ + "img/security-3-supp.44091ea6.png";